import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_EUROPEAN_UNION_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    areYouClaimingForRentalCarDamage: 'false',
    doYouHaveOtherTypeOfPetInsurance: 'false',
    dateOfLoss: '',
    pleaseDescribeWhatOccurred: '',
    placeOfLoss: '',
    address: '',
    cityOrTown: '',
    country: '',
    postalCode: '',
    contact: '',
    phoneNumber: '',
    expenseDescriptionOfItems: [],
    companyNameForOther: '',
    addressForOther: '',
    typeOfPolicyForOther: '',
    policyForOther: '',
    contactForOther: '',
    phoneForOther: '',
    cityOrTownForOther: '',
    countryForOther: '',
    postalCodeForOther: '',
    origination: '',
    flightNumberOrigination: '',
    airCarrierOrigination: '',
    destination: '',
    flightNumberDestination: '',
    airCarrierDestination: '',
    nameOfTourOperatorOrCruiseOrLineOrAirline: '',
    schoolName: '',
  },
  errors: [],
});

const initialEuropeanUnionState = {
  form: {
    forEUCitizens: 'false',
    ifYesWasTheEHIC: 'false',
    ifNoPleaseExplain: '',
  },
};

function collisionDamageStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_EUROPEAN_UNION_STATE:
      return state.mergeDeep(initialEuropeanUnionState);
    default:
      return state;
  }
}

export default collisionDamageStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.CollisionDamageStep/reducer.js